const Flayer=({data={}})=>{    
    return <div className="flayer" style={{background:`url(${data.flayer})`,backgroundSize:'85% auto',backgroundPosition:'center center',backgroundRepeat:'no-repeat'}}/>
};
export default Flayer;
